export class AppConfig {
  static get ApiUrl(): string {
    return `${process.env.REACT_APP_API_URL}`;
  }
}
